import * as React from "react";

import { TextAreaProps } from "./TextArea.props";

const TextArea = ({ onChange, onBlur, value, disabled = false }: TextAreaProps) => (
	<textarea
		disabled={disabled}
		onChange={onChange}
		onBlur={onBlur}
		value={value}
		className="form-control"
		placeholder="Комментарий"
		style={{
			marginTop: "1rem",
			resize: "none"
		}}
	/>
);

export { TextArea }
